import { Paper } from '@material-ui/core';
import React from 'react'
import { Box, Container, Typography } from '@material-ui/core';

export default function DataDeletion(props) {
    return (
        <div>
         <Container maxWidth="lg" style={{display: 'flex'}}>
            <Paper elevation={10} component={Box} margin={2} p={5} >
                
    <p><strong><h1>Account & Data Deletion Request</h1></strong></p>
    
    <p>At <strong>Shopie Bazar</strong>, we respect your privacy and your right to control your personal data. If you wish to delete your account and associated data, please follow the steps below.</p>

    <p><strong><h2>How to Request Account Deletion</h2></strong></p>
    
    <p>To request the deletion of your Shopie Bazar account and associated data, please follow these steps:</p>
    
    <ol>
        <li><strong>Email Us:</strong> Send an email to <a href="mailto:support@shopiebazar.com" style={{color: '#1976d2', textDecoration: 'none'}}>support@shopiebazar.com</a></li>
        <li><strong>Subject Line:</strong> Use "Account Deletion Request" as your subject line</li>
        <li><strong>Include Required Information:</strong>
            <ul>
                <li>Your registered email address</li>
                <li>Your phone number (if provided during registration)</li>
                <li>Reason for deletion (optional)</li>
            </ul>
        </li>
        <li><strong>Verification:</strong> We may ask you to verify your identity before processing the deletion request</li>
        <li><strong>Confirmation:</strong> You will receive a confirmation email once your request has been processed</li>
    </ol>

    <p><strong><h2>What Data Will Be Deleted</h2></strong></p>
    
    <p>When you request account deletion, the following data will be permanently removed from our systems:</p>
    
    <ul>
        <li><strong>Account Information:</strong> Email address, phone number, name, and profile details</li>
        <li><strong>Personal Data:</strong> Shipping addresses, billing information, and payment details</li>
        <li><strong>Order History:</strong> Past purchases, order details, and transaction records</li>
        <li><strong>App Usage Data:</strong> Search history, browsing preferences, and app interactions</li>
        <li><strong>Communication Records:</strong> Customer support conversations and feedback</li>
        <li><strong>Device Information:</strong> Device identifiers and app-specific data</li>
    </ul>

    <p><strong><h2>Data Retention & What We Keep</h2></strong></p>
    
    <p>Some information may be retained for legitimate business purposes as required by law:</p>
    
    <ul>
        <li><strong>Financial Records:</strong> Transaction data may be retained for up to 7 years for tax and accounting purposes</li>
        <li><strong>Legal Compliance:</strong> Data required for legal compliance, fraud prevention, or dispute resolution</li>
        <li><strong>Anonymized Analytics:</strong> Aggregated, non-personally identifiable data for business analytics</li>
    </ul>

    <p><strong><h2>Processing Time</h2></strong></p>
    
    <p>Account deletion requests are typically processed within <strong>30 days</strong> of verification. You will receive email confirmation once the deletion is complete.</p>

    <p><strong><h2>Important Notes</h2></strong></p>
    
    <ul>
        <li>Account deletion is <strong>permanent and irreversible</strong></li>
        <li>You will lose access to all order history and account benefits</li>
        <li>Any pending orders or returns must be completed before deletion</li>
        <li>Gift cards or store credits associated with your account will be forfeited</li>
    </ul>

    <p><strong><h2>Alternative Options</h2></strong></p>
    
    <p>If you're concerned about privacy but don't want to delete your account entirely, consider these alternatives:</p>
    
    <ul>
        <li><strong>Account Deactivation:</strong> Temporarily disable your account</li>
        <li><strong>Data Minimization:</strong> Remove specific personal information while keeping your account</li>
        <li><strong>Privacy Settings:</strong> Adjust your privacy preferences in the app settings</li>
    </ul>

    <p><strong><h2>Contact Information</h2></strong></p>
    
    <p>For any questions about data deletion or privacy concerns, please contact us:</p>
    
    <ul>
        <li><strong>Email:</strong> <a href="mailto:support@shopiebazar.com" style={{color: '#1976d2', textDecoration: 'none'}}>support@shopiebazar.com</a></li>
        <li><strong>Subject:</strong> Data Privacy Inquiry</li>
    </ul>

    <p style={{marginTop: '2rem', fontSize: '0.9rem', color: '#666'}}>
        <em>This page complies with Google Play Store data deletion requirements. Last updated: August 2025</em>
    </p>

            </Paper>
        </Container>
        </div>
    )
}
